import React from "react";
import classes from "./Contacts.module.css";
import { NAIL_SHOP_INFO } from "../../utils/Const";
import { images } from "../../assets/img";
import BookNowBtn from "../BookNowBtn";

const Contacts = (props) => {
  return (
    <div ref={props?.contactsRef} className={classes.contacts}>
      <div className={classes.contactsContainer}>
        <h1>{"CONTACT"}</h1>

        <a
          target={"_blank"}
          rel="noreferrer"
          href={`tel:${NAIL_SHOP_INFO.tel}`}
        >{`PHONE: ${NAIL_SHOP_INFO.phone}`}</a>
        <a
          target={"_blank"}
          rel="noreferrer"
          href={`mailto:${NAIL_SHOP_INFO.email}`}
        >{`EMAIL: ${NAIL_SHOP_INFO.email}`}</a>
        <a
          target={"_blank"}
          rel="noreferrer"
          href={`${NAIL_SHOP_INFO.ggMapUrl}`}
        >{`ADDRESS: ${NAIL_SHOP_INFO.address}\n `}</a>
        <BookNowBtn
          onClick={() => window.open(NAIL_SHOP_INFO.ggMapUrl, "_blank")}
          isShowArrow={false}
          title={"GET DIRECTION"}
          style={classes.bookNowBtn}
        />

        <h1>{"\nOPENING HOURS"}</h1>
        <a
          target={"_blank"}
          rel="noreferrer"
          href={`${NAIL_SHOP_INFO.ggMapUrl}`}
        >
          {`${NAIL_SHOP_INFO.openingTime.openTime.weekdays}: ${NAIL_SHOP_INFO.openingTime.openTime.time}`}
        </a>
        <a
          target={"_blank"}
          rel="noreferrer"
          href={`${NAIL_SHOP_INFO.ggMapUrl}`}
        >
          {`${NAIL_SHOP_INFO.openingTime.closeTime.weekdays}: ${NAIL_SHOP_INFO.openingTime.closeTime.time}`}
        </a>

        <div>
          <a target={"_blank"} href={NAIL_SHOP_INFO.instagram} rel="noreferrer">
            <img
              className={classes.contactsContainerImg}
              alt={"insta"}
              g
              src={images.instaIcon}
            />
          </a>
          <a target={"_blank"} href={NAIL_SHOP_INFO.facebook} rel="noreferrer">
            <img
              className={`${classes.contactsContainerImg} ${classes.marginLeftFBIcon}`}
              alt={"facebook"}
              src={images.fbIcon}
            />
          </a>
        </div>
        <BookNowBtn isShowArrow={false} style={classes.bookNowBtn} />
      </div>

      <iframe
        title="google-map"
        className={classes.iframe}
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d558.3515105772922!2d-3.1832385!3d55.9596659!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4887c7668f8d477b%3A0xd7d5bb960527b775!2sShine%20My%20Nails%20(%20Elm%20Row)!5e0!3m2!1sen!2s!4v1723364080802!5m2!1sen!2s"
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
};

export default Contacts;
